import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
const AssetsRow = ({
  onClick,
  id: propsID,
  data: _data = {},
  index,
  isSelected,
  onSelect
}) => {
  const {
    alias,
    id,
    name
  } = _data;
  const handleClick = () => onClick(propsID);
  const handleSelect = onSelect.bind(this, id);
  let displayName = name;
  if (!displayName) {
    displayName = /*#__PURE__*/React.createElement("span", {
      style: {
        color: 'lightgray'
      }
    }, "Asset without ID");
  }
  return /*#__PURE__*/React.createElement("tr", {
    style: {
      height: '30px'
    },
    className: `t-ar-${index} t-ar-name-${kebabCase(name)}`
  }, /*#__PURE__*/React.createElement("td", {
    "aria-label": "select-asset-checkbox",
    style: {
      width: '1px',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "t-ar-check",
    type: "checkbox",
    checked: isSelected,
    onChange: handleSelect
  })), /*#__PURE__*/React.createElement("td", {
    className: `t-ar-${index}-name`,
    onClick: handleClick,
    onKeyPress: handleClick,
    role: "button"
  }, name), /*#__PURE__*/React.createElement("td", {
    onClick: handleClick,
    onKeyPress: handleClick,
    role: "button"
  }, alias));
};
AssetsRow.propTypes = {
  data: PropTypes.shape({
    alias: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string
  }),
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
};
export default AssetsRow;